import React, { useState, useRef } from 'react';
import './MarriottOnline.css';
import CurvedHeader from './CurvedHeader';
import OptimizedImage from './OptimizedImage';

import imgHomepage from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_Homepage.png';
import imgHomepageavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_Homepage.avif';
import imgHomepagewebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_Homepage.webp';
import imgHotelSite from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_HotelSite.png';
import imgHotelSiteavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_HotelSite.avif';
import imgHotelSitewebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_HotelSite.webp';
import imgOffersPage from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_OffersPage.png';
import imgOffersPageavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_OffersPage.avif';
import imgOffersPagewebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_OffersPage.webp';
import imgLoyaltyPage from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_LoyaltyPage.png';
import imgLoyaltyPageavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_LoyaltyPage.avif';
import imgLoyaltyPagewebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_LoyaltyPage.webp';
import imgAccountPage from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_AccountPage.png';
import imgAccountPageavif from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_AccountPage.avif';
import imgAccountPagewebp from 'url:../../assets-optimized/redesign/solutions/marriott-digital/marriot-online/LaptopMockUp_AccountPage.webp';

const TABS = [
  { id: 'HOMEPAGE', img: { avif: imgHomepageavif, webp: imgHomepagewebp, fallback: imgHomepage } },
  {
    id: 'HOTEL WEBSITES',
    img: { avif: imgHotelSiteavif, webp: imgHotelSitewebp, fallback: imgHotelSite },
  },
  {
    id: 'OFFERS PAGE',
    img: { avif: imgOffersPageavif, webp: imgOffersPagewebp, fallback: imgOffersPage },
  },
  {
    id: 'LOYALTY PAGE',
    img: { avif: imgLoyaltyPageavif, webp: imgLoyaltyPagewebp, fallback: imgLoyaltyPage },
  },
  {
    id: 'ACCOUNT PAGES',
    img: { avif: imgAccountPageavif, webp: imgAccountPagewebp, fallback: imgAccountPage },
  },
];

export default function MarriottOnline() {
  const [activeTab, setActiveTab] = useState(TABS[0].id);
  const contentRef = useRef(null);

  const scrollToContent = () => {
    contentRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className='marriott-online'>
      <CurvedHeader
        title='MARRIOTT ONLINE'
        pills={[
          {
            titleBold: '20+',
            textLight: 'ad units across owned digital',
            icon: (
              <svg
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <path d='M23 6l-9.5 9.5-5-5L1 18' />
                <path d='M17 6h6v6' />
              </svg>
            ),
          },
          {
            titleBold: '',
            textLight: 'Over 30 Hotel Websites',
            icon: (
              <svg
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M3.462 14.25C3.1165 14.25 2.82825 14.1345 2.59725 13.9035C2.36625 13.6725 2.2505 13.384 2.25 13.038V4.962C2.25 4.6165 2.36575 4.32825 2.59725 4.09725C2.82875 3.86625 3.11675 3.7505 3.46125 3.75H14.5387C14.8837 3.75 15.1718 3.86575 15.4028 4.09725C15.6338 4.32875 15.7495 4.617 15.75 4.962V13.0388C15.75 13.3838 15.6343 13.672 15.4028 13.9035C15.1713 14.135 14.8833 14.2505 14.5387 14.25H3.462ZM3.462 13.5H11.25V10.587H3V13.0388C3 13.1538 3.048 13.2595 3.144 13.356C3.24 13.4525 3.34575 13.5005 3.46125 13.5M12 13.5H14.5387C14.6538 13.5 14.7595 13.452 14.856 13.356C14.9525 13.26 15.0005 13.154 15 13.038V6.92325H12V13.5ZM3 9.837H11.25V6.9225H3V9.837Z'
                  fill='white'
                />
              </svg>
            ),
          },
        ]}
        backgroundColor='#1a1a1a'
        titleColor='white'
        pillBackgroundColor='white'
        pillTextColor='#1a1a1a'
        pillIconBackgroundColor='#1a1a1a'
        pillIconColor='white'
        arrowColor='white'
        onArrowClick={scrollToContent}
      />

      <div className='marriott-online__content-wrapper' ref={contentRef}>
        <div className='marriott-online__content'>
          <div className='marriott-online__tabs-container'>
            <div className='marriott-online__tabs'>
              {TABS.map((tab) => (
                <div key={tab.id} className='marriott-online__tab-wrapper'>
                  <button
                    className={`marriott-online__tab ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                    onMouseEnter={() => setActiveTab(tab.id)}
                  >
                    {tab.id}
                  </button>
                  {activeTab === tab.id && (
                    <div className='marriott-online__tab-arrow'>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      >
                        <path d='M5 12h14' />
                        <path d='M12 5l7 7-7 7' />
                      </svg>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className='marriott-online__image-container'>
            {TABS.map((tab) => (
              <OptimizedImage
                key={tab.id}
                avif={tab.img.avif}
                webp={tab.img.webp}
                fallback={tab.img.fallback}
                alt={`Marriott Digital Laptop - ${tab.id}`}
                className={`marriott-online__image-transition ${activeTab === tab.id ? 'active' : ''}`}
              />
            ))}
          </div>

          <div className='marriott-online__details'>
            <h3 className='marriott-online__details-title'>
              WHERE A TRIP <br className='desktop-only' />
              BECOMES REAL
            </h3>
            <p className='marriott-online__details-text'>
              As travelers move from inspiration to action, your brand sits alongside the choices
              they're making. This is when intent is highest and attention is focused.
            </p>
            <div className='marriott-online__stats-card'>
              <h4>150M ENGAGED USERS</h4>
              <p>
                Defined as trailing 2-year active <span className='no-wrap'>Marriott Bonvoy</span>{' '}
                members”
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
